import { adminMutation } from "@/admin/utils/adminMutation.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { urlEncodedBody } from "@/utils/fetchClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type {
    CustomBillableProduct,
    CustomBillableProductCreateBody,
    CustomBillableProductModifyBody,
} from "@warrenio/api-spec/spec.oats.gen";

type Response = CustomBillableProduct[];

const queryKey: QueryKey = ["custom_products"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<Response> =>
            getResponseData(await client.GET("/charging/admin/products", { signal })),
    });
}

export const queryAtom = atomFromStandardQueryOptions(getQuery);

//#region Mutations
const entity = "Custom product";

export const customCreateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "create",
    requestFn: async ({ body }: { body: CustomBillableProductCreateBody }) =>
        await apiClient.POST("/charging/admin/products", {
            ...urlEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

export const customUpdateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "update",
    requestFn: async ({ body, uuid }: { body: CustomBillableProductModifyBody; uuid: string }) =>
        await apiClient.PATCH("/charging/admin/products/{uuid}", {
            params: { path: { uuid } },
            ...urlEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));
//#endregion Mutations
